import { render, staticRenderFns } from "./approvalSet.vue?vue&type=template&id=281dcefc&scoped=true&"
import script from "./approvalSet.vue?vue&type=script&lang=js&"
export * from "./approvalSet.vue?vue&type=script&lang=js&"
import style0 from "./approvalSet.vue?vue&type=style&index=0&lang=less&"
import style1 from "./approvalSet.vue?vue&type=style&index=1&id=281dcefc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281dcefc",
  null
  
)

export default component.exports